import { Grid } from '@mui/material'
import { Container } from '@mui/system'
import React from 'react'
import { Btn, Heading, P, SectionWrapper } from '../../Styles/style'
import styled from '@emotion/styled'
import colorbg from '../../../assets/colorbg.png'
import Metamask from '../../../assets/metamask.png'
import buyuniswap from '../../../assets/buyuniswap.png'

const WhyWrapper = styled.div`
padding: 12rem 0;
background-image: url(${colorbg});
min-height: 100vh;
background-size: cover;
display: flex;
    align-items: center;
`
const SectionHeading = styled.div`
font-size: 50px;
text-align: center;
font-family: "Poppins-Bold";
padding: 30px 0;
@media screen and (max-width:599px){
     font-size: 40px;

}
`
const SectionSubHeading = styled.div`
font-size: 30px;
color: #BA51FF;
  font-family: "Poppins-SemiBold";
  max-width: 60%;
`
const SocialMediaDiv = styled.div`
display:flex;
`
const FactsWrapper = styled.div`
border: ${(props) => props.bg ? props.bg : '1px solid #F7841B'};
position: relative;
padding:80px 30px 20px 30px;
border-radius: 10px;
@media screen and (max-width:599px){
     margin: 20px 0;
     
}
`
const FactSmallimg = styled.img`
width: 100%;
height: auto;
max-width: 120px;
position: absolute;
top: -60px;
`
const FactHeading = styled.div`
display: flex;
font-size:24px ;
padding-left: 10px;
font-family: "Poppins-Bold";
`
const Intall = styled.button`
padding: 10px ;
background-color: ${(props) => props.bg ? props.bg : '#F7841B'};
border-radius: 6px;
color: #fff;
border: none;
margin-top: 10px;
font-weight: 900;
`
const Protocol = () => {
     return (
          <div>
               <SectionWrapper p="3rem 0" id="howtobuy">
                    <Container maxWidth="xl">

                         <SectionHeading>How To Buy
                         </SectionHeading>
                         <Grid container rowSpacing={4} columnSpacing={8} style={{ placeContent: 'center', padding: "70px 0" }}>
                              <Grid item xs={12} sm={6}>
                                   <FactsWrapper>

                                        <FactSmallimg src={Metamask} />
                                        <FactHeading>Create a Metamask Wallet
                                        </FactHeading>
                                        <P m="20px 0 0">Connect MetaMask to uniswap purchase Sanshu Inu tokens. If you don’t have MetaMask, simply download the MetaMask app on your phone or browser extension. 
</P>
                                        <Intall>Install Metamaks</Intall>

                                   </FactsWrapper>

                              </Grid>
                              <Grid item xs={12} sm={6}>
                                   <FactsWrapper bg="1px solid #F51E79">
                                        <FactSmallimg src={buyuniswap} />
                                        <FactHeading>
                                             Buy on uniswap
                                        </FactHeading>
                                        <P m="20px 0 0">To buy Sanshu tokens, simply click the uniswap button below or copy the Sanshu Inu contract address above and paste it into uniswap to purchase the tokens. Make sure slippage is set to 6-10%.
</P>
                                        <Intall bg="#F51E79">Buy on Uniswap</Intall>
                                   </FactsWrapper>
                              </Grid>
                              <Grid item xs={12} md={6} style={{ textAlign: 'end', padding: '3.5rem 0' }}>
                              </Grid>
                         </Grid>
                    </Container>
               </SectionWrapper>
          </div>
     )
}

export default Protocol